<template>
    <div class="card-container" v-once>
        <component
            :is="link ? 'a' : 'div'"
            class="fake-card__content"
            :href="link || null"
        >
            <picture>
                <source 
                    srcset="/images/events/2026/october-used-cars/fake-card@2x.webp" 
                    type="image/webp"
                >
                <img 
                    class="fake-card__image img-responsive"
                    src="/images/events/2026/october-used-cars/fake-card@2x.png"
                    alt="Used Cars"
                >
            </picture>
        </component>
    </div>
</template>

<script>
export default {
    props: {
        link: {
            type: String,
            default: null
        }
    }
};
</script>

<style lang="scss">
.card-container {
	box-shadow: 0px 11px 24px rgba(0,0,0,0.15);
	border-radius: 10px;
    width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: stretch;
    background: #003c38;
    position: relative;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;

    .no-webp & {
   
        background-image: url("/images/events/2026/october-used-cars/fake-card-bg.jpg");
    }

    .webp & {
        background-image: url("/images/events/2026/october-used-cars/fake-card-bg.webp");
    }

    @media only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx) {
        .no-webp & {
            background-image: url("/images/events/2026/october-used-cars/fake-card-bg@2x.jpg");
        }
        .webp & {
            background-image: url("/images/events/2026/october-used-cars/fake-card-bg@2x.webp");
        }
    }
}
</style>